module.exports = __webpack_public_path__ + "img/home-1.1ed4d147.png";